import { render } from "./scope1ActivityRecorderDetail.vue?vue&type=template&id=7aa8e3dc&ts=true"
import script from "./scope1ActivityRecorderDetail.vue?vue&type=script&lang=ts"
export * from "./scope1ActivityRecorderDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__